import { jsxs as s, jsx as i } from "react/jsx-runtime";
const h = ({
  size: r = 20,
  color: t = "currentColor",
  className: e,
  ...o
}) => /* @__PURE__ */ s("svg", { className: e, viewBox: "0 0 24 24", fill: "none", width: r, height: r, ...o, children: [
  /* @__PURE__ */ i(
    "path",
    {
      d: "M11.8998 4H11.6577C11.4227 3.99965 11.1916 4.05936 10.9862 4.17345C10.7808 4.28755 10.608 4.45225 10.4842 4.65192L2.2142 17.8858C2.07469 18.1059 2.00042 18.361 2 18.6215C1.99998 18.8041 2.03624 18.9849 2.10667 19.1533C2.1771 19.3218 2.2803 19.4746 2.41027 19.6028C2.54024 19.731 2.69439 19.8322 2.86377 19.9003C3.03316 19.9685 3.21439 20.0023 3.39696 19.9999H20.1605C20.5261 19.9999 20.8766 19.8547 21.1351 19.5962C21.3936 19.3377 21.5388 18.9871 21.5388 18.6215C21.5384 18.361 21.4641 18.1059 21.3246 17.8858L13.0733 4.65192C12.9494 4.45225 12.7766 4.28755 12.5713 4.17345C12.3659 4.05936 12.1347 3.99965 11.8998 4Z",
      stroke: t,
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }
  ),
  /* @__PURE__ */ i("path", { d: "M11.7787 8.44238V13.7788", stroke: t, strokeWidth: "1.5", strokeMiterlimit: "10" }),
  /* @__PURE__ */ i("path", { d: "M11.7787 15.5575V17.3363", stroke: t, strokeWidth: "1.5", strokeMiterlimit: "10" })
] });
export {
  h as WarningIcon
};
